<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
	  <z-page title="Pengurusan Inventori">
      <div class="table_scrol">
        <div class="w-card__content content-hardcode mb3">
         <w-select class="mt4" label="Peranan" :items="roles" @input="cari()"  v-model="pencarian.role_id" />
            <w-form v-model="valid" @validate="cari" ref="frm">
         
          <w-flex class="mt2">
            <div class="xs6">
              <div class="spacer"></div>
              <div class="spacer"></div>
               <w-input
               v-model="pencarian.no_batch"
               label="No. Batch"
               />
            </div>
            <div class="xs6">
              <div class="spacer"></div>
               <z-select
               v-model="pencarian.se_katalog_id"
               :items="se_katalog"
               label="ID Ternakan"
               style="margin-top: -0.4px;"
               />
            </div>
            
          </w-flex>
          <w-flex class="mt2">
            <div class="xs6">
              <div class="spacer"></div>
              <div class="spacer"></div>
               <z-select
               v-model="pencarian.lkp_ternakan_id"
               :items="lkp_ternakan"
               label="Jenis Ternakan"
               style="margin-top: -0.4px;"
               />
            </div>
            <div class="xs6">
              <div class="spacer"></div>
               <z-select
               v-model="pencarian.lkp_baka_id"
               :items="lkp_baka"
               label="Baka"
               style="margin-top: -0.4px;"
               />
            </div>
            
          </w-flex>
        </w-form>

        <w-flex justify-end class="mt2">
                      <w-button class="mr2" v-on:click="resetPencarian()" v-on="on" bg-color="warning">
                    <w-icon class="mr1" md >fal fa-redo</w-icon>SET SEMULA
                </w-button>
                      <w-button class="mr2" bg-color="primary"  v-on="on" @click="$refs.frm.validate()">
                    <w-icon class="mr1" md >fal fa-search</w-icon>CARI
                </w-button>
        </w-flex>
      </div>
      <z-table title="Senarai Pengurusan Inventori" :headers="table.headers" :items="table.items" :meta="table.meta">
          <template #header-label="{ header, label, index }">
          </template>
            <template #item-cell.jumlah_agih="{ item, label, header, index }">
               <div style="text-align: center;">
                  <template v-if="item.jumlah_agih == null">0</template>
                  <template v-else>{{item.jumlah_agih}}</template>
               </div>
            </template>
            <template #item-cell.rusak="{ item, label, header, index }">
               <div style="text-align: right;">
                  {{item.rusak}}
               </div>
            </template>
            <template #item-cell.hilang="{ item, label, header, index }">
               <div style="text-align: right;">
                  {{item.hilang}}
               </div>
            </template>
            <template #item-cell.terpakai="{ item, label, header, index }">
               <div style="text-align: right;">
                  {{item.terpakai}}
               </div>
            </template>
            <template #item-cell.action="{ item, label, header, index }">
               <w-flex class="flex justify-center">
                  <w-tooltip top color="white" bg-color="black">
                        <template #activator="{ on }">
                           <w-button  bg-color="warning" v-on="on"  @click="kemaskini(item)" class="be fs-2"><div style="width: 8px"></div>
                              <w-icon md class="mr2">fal fa-pencil</w-icon>
                           </w-button>
                        </template>
                        Kemaskini
                     </w-tooltip>
                  &nbsp;  
               </w-flex>
            </template>
      </z-table>
      </div>
	  </z-page>
      <w-dialog
         v-model="dialog.show"
         :fullscreen="dialog.fullscreen"
         :width="dialog.width"
         :persistent="dialog.persistent"
         :persistent-no-animation="dialog.persistentNoAnimation"
         title-class="primary-dark1--bg white">
         <template #title>
            <w-icon class="mr2">fal fa-cog</w-icon>
               {{dialog.title}}
         </template>
         <w-form
            ref="form"
            v-model="dialog.valid"
            class="stok-form"
            @validate="simpan"
            @success="success"
            >
            <!-- Terpakai -->
            <div class="form-group">
               <z-input
                  label="Bil Terpakai"
                  v-model="form.terpakai"
                  name="terpakai"
                  readonly
                  outline
               />
            </div>

            <!-- Rusak -->
            <div class="form-group">
               <label class="form-label">
                  Bil. Rosak Asal
                  <span class="value">{{ rusak_asal }}</span>
               </label>

               <z-input
                  label="Bil Straw Dilupus / Rosak"
                  v-model="form.rusak_new"
                  type="number"
                  :min="rusak_asal"
                  :max="baki_asal"
                  name="rusak"
                  outline
                  @input="countKuantiti(form, 1)"
               />
            </div>

            <!-- Hilang -->
            <div class="form-group">
               <label class="form-label">
                  Bil. Hilang Asal
                  <span class="value">{{ hilang_asal }}</span>
               </label>

               <z-input
                  label="Bil Straw Diuji"
                  v-model="form.hilang_new"
                  type="number"
                  :min="hilang_asal"
                  :max="baki_asal"
                  name="hilang"
                  outline
                  @input="countKuantiti(form, 2)"
               />
            </div>

            <!-- Baki -->
            <div class="form-group">
               <z-input
                  type="number"
                  label="Baki Straw"
                  v-model="form.baki"
                  name="baki"
                  readonly
                  outline
                  class="baki-input"
               />
            </div>
            </w-form>
         <template #actions>
            <div class="spacer" />
            <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 11px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog.show = false">TUTUP</w-button>
            <w-button 
            class="ml1" 
            v-if="form.baki > 0 "
            :loading="dialog.loading"
            @click="$refs.form.validate()"
            >
              SIMPAN
            </w-button>
         </template>
      </w-dialog>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
    roles: [Array, Object],
    role: String,
  },
  data() {
    return {
      resourceurl: 'se.inventori',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan Semen Beku', route: '/se' },
        { label: 'Pengurusan Inventori', route: '/se/inventori' },
      ],
      pencarian: {
         no_batch: '',
         se_katalog_id: '',
         lkp_ternakan_id: '',
         lkp_baka_id: '',
         role_id: this.role
      },
      pasung_list:[
        {value: 1, label: "Pindah Milik"},
      ],
      se_katalog: [],
      lkp_ternakan: [],
      lkp_baka: [],
      form: [],
      pindahmilik: 0,
      baki_asal: 0,
      rusak_asal: 0,
      hilang_asal: 0,
      juruteknik_list: [],
      
    }
  },
   computed: {
      maxRusak() {
         return this.baki_asal - (this.form.hilang_new || 0)
      },
      maxHilang() {
         return this.baki_asal - (this.form.rusak_new || 0)
      }
   },
  methods: {
    cari() {
       if(!this.valid) return;

       let params = {
       ...this.pencarian,
       };
       params.page = 1;
       params.per_page =9999;
       this.$inertia.visit(route(route().current(), params), {
           preserveState: true,
           preserveScroll: true,
       });
    },
    resetPencarian() {
       this.$inertia.visit(route(route().current()));
    },
    getKatalog(){
      this.$zcomm.get(this.api_service + 'lookup/id_ternakan', {}).then(res => {
        this.se_katalog = res
      })
    },

      countKuantiti(data, jenis){

         if (data.hilang_new > 0 || data.rusak_new  > 0) {
            var hilang_rusak = Number(data.rusak_new ) + Number(data.hilang_new );
            data.baki = Number(this.baki_asal) - Number(hilang_rusak);
         } else {
            data.baki = this.baki_asal;
         }
         console.log("Sesudah:", data.baki);
         // if (data.hilang > 0 || data.rusak > 0) {
         //    var hilang_rusak = data.rusak + data.hilang;
         //    data.baki = this.baki_asal - hilang_rusak;
         //    // this.countHilang();
         // }
      },
      countHilang(data){
         data.baki = this.baki_asal - data.hilang;
      },
      getJuruteknik(data){
         if (this.$page.props.auth.user.lkp_negeri_id) {
            this.$zcomm.get(this.api_service + 'lookup/juruteknik/'+this.$page.props.auth.user.lkp_negeri_id+'/1'+'/0', {}).then(res => {
               this.juruteknik_list = res
            })
         }
      },
      getJenisTernakan(){
         this.$zcomm.get(this.api_service + 'lookup/ternakan', {}).then(res => {
           this.lkp_ternakan = res
         })
       },

       getBaka(){
         this.$zcomm.get(this.api_service + 'lookup/baka_all', {}).then(res => {
           this.lkp_baka = res
        })
      },
      kemaskini(form){
          this.form = form;
          this.dialog.show = true
          this.baki_asal = form.baki;
          this.rusak_asal = form.rusak;
          this.hilang_asal = form.hilang;
          this.form.rusak_new = 0;
          this.form.hilang_new = 0;
          this.pindahmilik = 0;
          this.dialog.title = 'KEMASKINI'
          this.form.saveButton = "Save"
      },
      simpan() {
         this.dialog.loading = true
         if (this.form.no > 0) {
            this.form.role_id = this.pencarian.role_id ? this.pencarian.role_id :'';
            this.$zcomm.update(this.resourceurl + '.update', this.form.no, this.form)
            .then(res => {
                //update displayed record
                this.mapreturneddata(res)
                this.dialog.show = false;
              if (typeof this.onAfterEdit === "function") {
                  this.onAfterEdit()
                }
                this.$inertia.visit(this.$page.url)
            })
            .catch(err => {

            })
            .finally(() => {
                this.dialog.loading = false
                // this.dialog.show = false

            });
         }else{
            this.dialog.loading = false
         }
     },
    
  
  },

  watch: {

  },
  mounted() {
    this.getKatalog();
    this.getJuruteknik();
    this.getJenisTernakan();
    this.getBaka();
    this.dialog.width = 500
      
  },
}
</script>
<style>
.stok-form {
  padding: 12px 4px;
}

.form-group {
  margin-bottom: 14px;
}

.form-label {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  font-weight: 500;
  color: #555;
  margin-bottom: 6px;
}

.form-label .value {
  font-weight: 600;
  color: #1976d2;
}

/* .baki-input input {
  font-weight: 600;
  background-color: #f5f7fa;
} */

.z-input {
  margin-bottom: 2px;
}
</style>